module.exports = __webpack_public_path__ + "static/media/analytics-blue.43911131.svg";